// Entries are confirmed creation receipts, not unsaved form values. A summary
// can lag the accepted creation; requiring it here hid the new company entirely.
export const pendingRecentlyAddedCompanies = (recentlyAddedCompanies = [], summaryRows = [], tenantId) => {
  if (!tenantId) return [];
  const summarizedIds = new Set(summaryRows.map(row => row?.companyId).filter(Boolean));
  const pending = new Map();
  recentlyAddedCompanies.forEach(company => {
    if (company?.companyId && company.tenantId === tenantId && !summarizedIds.has(company.companyId)) {
      if (!pending.has(company.companyId)) pending.set(company.companyId, company);
    }
  });
  return [...pending.values()];
};

export const recentlyAddedCompanyRow = company => ({
  companyId: company.companyId,
  tenantId: company.tenantId,
  'Company Name': company.companyName,
  country: company.country,
  dnbCompanyId: company.dnbCompanyId,
  segmentID: company.segment?.id,
  createdAt: company.createdAt || company.addedAt,
  addedAt: company.addedAt,
  requestedCreditLimit: company.requestedCreditLimit,
  'Requested Limit': company.requestedCreditLimit,
  underwritingStatus: company.underwritingStatus,
  underwritingDispatchStatus: company.underwritingDispatchStatus,
  underwritingInProgress: company.underwritingInProgress,
  underwritingStartedAt: company.underwritingStartedAt,
  hasSummaryData: false,
  lastUnderwritingDate: null,
});
